import styled from 'styled-components';

export const Wrapper = styled.section`
  width: 100%;
  margin: 0 auto;
`;

export const EyebrowWrapper = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

export const QuoteWrapper = styled.div`
  text-align: center;
  margin: 0 auto 24px auto;
  max-width: 800px;
`;

export const CarouselWrapper = styled.div`
  text-align: center;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;
